import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth is carried by the httpOnly `session_token` cookie set by the backend.
// The bearer token is kept in memory only (never persisted) as a same-session fallback.
let memoryToken = null;

api.interceptors.request.use((config) => {
  if (memoryToken) config.headers.Authorization = `Bearer ${memoryToken}`;
  return config;
});

export function saveToken(t) { memoryToken = t || null; }
export function clearToken() { memoryToken = null; }
export function getToken() { return memoryToken; }
